"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "FormattedTime", {
  enumerable: true,
  get: function get() {
    return _FormattedTime.default;
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider.default;
  }
});
Object.defineProperty(exports, "Direction", {
  enumerable: true,
  get: function get() {
    return _constants.Direction;
  }
});
exports.PlayerIcon = void 0;

var _Button = _interopRequireDefault(require("./components/Button.js"));

var _FormattedTime = _interopRequireDefault(require("./components/FormattedTime.js"));

var PlayerIcon = _interopRequireWildcard(require("./components/icons.js"));

exports.PlayerIcon = PlayerIcon;

var _Slider = _interopRequireDefault(require("./components/Slider.js"));

var _constants = require("./constants.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-player-controls/dist/index.js
// module id = 1030
// module chunks = 168707334958949